import dynamic from 'next/dynamic'

export const HeroV2Carousel = dynamic(() => import('./hero-v2-carousel'))
